import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmmaInputDirective } from './emma-input.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    EmmaInputDirective
  ],
  exports: [
    EmmaInputDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class EmmaInputModule { }
